'use strict';

var Collapse = require('./collapse');

var Calendar = function(config) {

  var self = this;
  var $html = $('html');
  var $item = config.filterItem;
  var $button = config.button;
  var $calendar = config.calendar;
  var $calendarOuter = config.calendarOuter;
  var $calendarInner = config.calendarInner;
  var $eventsEl = config.calendarEventsEl;
  var template = config.calendarTemplateEl.html();
  var events;

  if ($eventsEl.length) {
    events = JSON.parse($eventsEl.html());
  }

  self.initClndr = function() {

    if ($html.attr('lang') === 'ca') {
      moment.locale('ca');
    } else if ($html.attr('lang') === 'es' || $html.attr('lang') === 'es-ES') {
      moment.locale('es');
    } else if ($html.attr('lang') === 'en') {
      moment.locale('en');
    }

    $calendarInner.clndr({
      events: events,
      template: template,
      moment: moment,
      targets: {
        day             :  'filters__calendar-day',
        nextButton      :  'filters__calendar-next',
        previousButton  :  'filters__calendar-prev'
      },
      classes: {
        adjacentMonth  :  'filters__calendar-day -adjacent-month',
        today          :  'filters__calendar-day -today',
        event          :  'filters__calendar-day -event',
        selected       :  'filters__calendar-day -selected'
      },
      clickEvents: {
        click: function(target) {
          console.log(target);
        }
      }
    });
  }

  self.init = function() {

    if ($calendar.length) {
      self.initClndr();
      new Collapse($item, $button, $calendar, $calendarOuter).init();
    }
  }
};

module.exports = Calendar;
